/* eslint-disable max-lines */
/* eslint-disable id-length */
/* eslint-disable no-duplicate-imports */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import dashboardIcon from '../../Assets/images/svg/dar_home.svg';
import selectedDashboardIcon from '../../Assets/images/svg/dar_selected_home.svg';
import managePropertyIcon from '../../Assets/images/svg/dar_manage_property.svg';
import allPropertiesIcon from '../../Assets/images/svg/all-properties.svg';
import businessIcon from '../../Assets/images/svg/dar_business.svg';
import favoriteIcon from '../../Assets/images/svg/dar_favorite.svg';
import logoutIcon from '../../Assets/images/svg/logout_icon.svg';
import userSquareIcon from '../../Assets/images/svg/dar_user_square.svg';
import selectedUserSquareIcon from '../../Assets/images/svg/dar_selected_user_square.svg';
import DesktopSideBar from './Desktop/desktop';
import { MODULE_NAMES } from '../../Constants/modules';
import { useAuth } from '../../Hooks/useAuth';

const menuItems = [
  {
    id: 1,
    icon: dashboardIcon,
    selectedIcon: selectedDashboardIcon,
    text: 'Home',
    link: '/',
    submenuItems: [],
    moduleName: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
  },
  {
    id: 2,
    icon: businessIcon,
    selectedIcon: businessIcon,
    text: 'Manage My Listing',
    link: '/my-properties',
    submenuItems: [],
    moduleName: MODULE_NAMES.PROPERTY_MANAGEMENT,
  },
  {
    id: 3,
    icon: managePropertyIcon,
    selectedIcon: managePropertyIcon,
    text: 'Manage My Properties',
    link: '/property-list',
    submenuItems: [],
    moduleName: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
  },
  {
    id: 7,
    icon: allPropertiesIcon,
    selectedIcon: allPropertiesIcon,
    text: 'Admin Portal',
    link: '/admin-portal',
    submenuItems: [],
    moduleName: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
    adminOnly: true,
  },
  {
    id: 4,
    icon: favoriteIcon,
    selectedIcon: favoriteIcon,
    text: 'Favourite Properties',
    link: '/saved-properties',
    submenuItems: [],
    moduleName: MODULE_NAMES.PROPERTY_MANAGEMENT,
  },
  {
    id: 6,
    icon: userSquareIcon,
    selectedIcon: selectedUserSquareIcon,
    text: 'My Profile',
    link: '/my-profile',
    submenuItems: [],
    moduleName: MODULE_NAMES.PROPERTY_MANAGEMENT,
  },
  {
    id: 5,
    icon: logoutIcon,
    selectedIcon: logoutIcon,
    text: 'Sign Out',
    link: null,
    isLogout: true,
    submenuItems: [],
    moduleName: MODULE_NAMES.PROPERTY_MANAGEMENT,
  },
];

const Sidebar = ({ isOpen, onToggle, screenWidth, Drawer }) => {
  const { user, userProfile } = useAuth();

  // Mobile uses header hamburger drawer; keep sidebar desktop-only.
  if (!screenWidth) {
    return null;
  }

  const roleId = user?.role_id ?? user?.roleId ?? userProfile?.role_id ?? userProfile?.roleId;
  const isAdmin = Number(roleId) === 1;

  // Show admin-only items only for role_id 1.
  const allowedMenuItems = useMemo(
    () => menuItems.filter((item) => !item.adminOnly || isAdmin),
    [isAdmin],
  );

  return (
    <DesktopSideBar
      menuItems={allowedMenuItems}
      isOpen={isOpen}
      onToggle={onToggle}
      Drawer={Drawer}
    />
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  screenWidth: PropTypes.bool.isRequired,
  Drawer: PropTypes.elementType.isRequired,
};

export default Sidebar;
